/* ICON WRAPPER — EVERY ICON INHERITS THE CURRENT TEXT COLOR */
const Icon = ({ size = 16, children }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        {children}
    </svg>
)

/* FILLED ICON WRAPPER — FOR THE SUITS, THEY READ BETTER AS SOLID SHAPES */
const Solid = ({ size = 16, children }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor">
        {children}
    </svg>
)


/* CLOSE ICON */
export const CloseIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M18 6 6 18M6 6l12 12" />
    </Icon>
)

/* CHECK ICON */
export const CheckIcon = ({ size = 12 }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 6 9 17l-5-5" />
    </svg>
)

/* PLUS ICON */
export const PlusIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M12 5v14M5 12h14" />
    </Icon>
)

/* ARROW ICON */
export const ArrowIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <path d="M5 12h14M13 6l6 6-6 6" />
    </Icon>
)

/* BACK ICON */
export const BackIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <path d="M19 12H5M11 18l-6-6 6-6" />
    </Icon>
)

/* EDIT ICON */
export const EditIcon = ({ size = 15 }) => (
    <Icon size={size}>
        <path d="M12 20h9" />
        <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" />
    </Icon>
)

/* TRASH ICON */
export const TrashIcon = ({ size = 15 }) => (
    <Icon size={size}>
        <path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6" />
    </Icon>
)

/* COIN ICON */
export const CoinIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="9" />
        <path d="M14.5 9.5a3 3 0 0 0-5 2.5 3 3 0 0 0 5 2.5" />
    </Icon>
)

/* STUDIO ICON */
export const StudioIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <path d="M3 20V9l9-5 9 5v11" />
        <path d="M3 20h18M9 20v-6h6v6" />
    </Icon>
)

/* INFO ICON */
export const InfoIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 11v5M12 8h.01" />
    </Icon>
)

/* LOCK ICON */
export const LockIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <rect x="4" y="11" width="16" height="10" rx="2" />
        <path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </Icon>
)

/* SEARCH ICON */
export const SearchIcon = ({ size = 15 }) => (
    <Icon size={size}>
        <circle cx="11" cy="11" r="7" />
        <path d="m20 20-3.5-3.5" />
    </Icon>
)

/* TABLE ICON — THE HEADER OF THE CREATE MODAL */
export const TableIcon = ({ size }) => (
    <Icon size={size}>
        <ellipse cx="12" cy="9" rx="9" ry="5" />
        <path d="M3 9v5a9 5 0 0 0 18 0V9" />
    </Icon>
)

/* LAYERS ICON — THE TYPE SECTION */
export const LayersIcon = ({ size }) => (
    <Icon size={size}>
        <path d="m12 3 9 5-9 5-9-5 9-5Z" />
        <path d="m3 13 9 5 9-5" />
    </Icon>
)

/* SLIDERS ICON — THE TABLE SECTION */
export const SlidersIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12M20 18h0" />
        <circle cx="16" cy="6" r="2" />
        <circle cx="10" cy="12" r="2" />
        <circle cx="18" cy="18" r="2" />
    </Icon>
)


/* SPADE — THE DEFAULT GAME ICON */
export const SpadeIcon = ({ size = 18 }) => (
    <Solid size={size}>
        <path d="M12 2.5C9.6 5.6 3.8 8.6 3.8 13a4.3 4.3 0 0 0 7.3 3.1c-.2 2-.9 3.6-2.3 4.7h6.4c-1.4-1.1-2.1-2.7-2.3-4.7a4.3 4.3 0 0 0 7.3-3.1c0-4.4-5.8-7.4-8.2-10.5Z" />
    </Solid>
)

/* CLUB — THE MULTIPLAYER TYPE */
export const ClubIcon = ({ size = 18 }) => (
    <Solid size={size}>
        <path d="M12 2.2a3.6 3.6 0 0 0-2.9 5.7 3.6 3.6 0 1 0-1.3 6.9c1 0 2-.4 2.7-1.1-.1 2.6-.8 4.6-2.4 6.1h7.8c-1.6-1.5-2.3-3.5-2.4-6.1.7.7 1.7 1.1 2.7 1.1a3.6 3.6 0 1 0-1.3-6.9A3.6 3.6 0 0 0 12 2.2Z" />
    </Solid>
)

/* DIAMOND — THE VIP TYPE */
export const DiamondIcon = ({ size = 18 }) => (
    <Solid size={size}>
        <path d="M12 2.2c2.6 3.7 5.4 6.8 7.4 9.8-2 3-4.8 6.1-7.4 9.8-2.6-3.7-5.4-6.8-7.4-9.8 2-3 4.8-6.1 7.4-9.8Z" />
    </Solid>
)

/* HEART — A FALLBACK TYPE */
export const HeartIcon = ({ size = 18 }) => (
    <Solid size={size}>
        <path d="M12 21.2c-.4 0-.7-.1-1-.4C7 17.4 3 14 3 9.6 3 6.6 5.3 4.3 8.2 4.3c1.5 0 2.9.7 3.8 1.8.9-1.1 2.3-1.8 3.8-1.8C18.7 4.3 21 6.6 21 9.6c0 4.4-4 7.8-8 11.2-.3.3-.6.4-1 .4Z" />
    </Solid>
)

/* CHIP — THE ROULETTE TYPE */
export const ChipIcon = ({ size = 18 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="9" />
        <circle cx="12" cy="12" r="3.5" />
        <path d="M12 3v3.5M12 17.5V21M3 12h3.5M17.5 12H21" />
    </Icon>
)

/* CARDS — THE BLACKJACK TYPE */
export const CardsIcon = ({ size = 18 }) => (
    <Icon size={size}>
        <rect x="3" y="6" width="11" height="15" rx="2" />
        <path d="M9.5 4.6 17 3l3.6 12.4a2 2 0 0 1-1.4 2.5l-1.7.5" />
    </Icon>
)

/* MONITOR — THE ELECTRON TYPE */
export const MonitorIcon = ({ size = 18 }) => (
    <Icon size={size}>
        <rect x="2.5" y="4" width="19" height="12.5" rx="2" />
        <path d="M8.5 20.5h7M12 16.5v4" />
    </Icon>
)


/* THE ICON OF A GAME TYPE — THE KEY OF THE TYPE PICKS IT, ANYTHING UNKNOWN FALLS BACK TO THE SPADE */
const TYPE_ICONS = {
    electron: MonitorIcon,
    multi: ClubIcon,
    vip: DiamondIcon,
    roulette: ChipIcon,
    blackjack: CardsIcon,
    poker: SpadeIcon,
    baccarat: HeartIcon,
}

export const TypeIcon = ({ type, size = 18 }) => {

    /* Fields */
    const Component = TYPE_ICONS[type] ? TYPE_ICONS[type] : SpadeIcon

    /* Send Result */
    return <Component size={size} />
}
